import React from "react";
import { Alert, Col, Form, Icon, Input, message, Row, Select } from "antd";

import { ResultsRandomization } from "../../components/Results/ResultsRandomization";

import {
  validateCustomForm,
  getCustomFormSchema,
  getRandomizationSites,
  getRandomizationSitesRequest,
  postCustomFormRandomization,
  postCustomFormSchema, postRandomizationInitialValuesRequest,
} from "../../api/requests";
import isAuthenticated from "../../utils/isAuthenticated";

import classes from "./RandomizePage.css";
import { Helmet } from "react-helmet";

import { withNamespaces } from "react-i18next";
import get from "lodash/get";
import FormBuilderCustomView from "../FormBuilder/FormBuilderCustomView";
import {
  getDrugManagementStatus,
  getProjectConfigurationPreRandomization,
  getPrerandomizationConsentStatus,
  getRandomizationConfirmStep,
  getUserShortTimezone,
  getUserTimezone, getRandomizationStopped, getRandomizationStatusMessage
} from "../../reducers/user/selectors";
import map from "lodash/map";
import find from "lodash/find";
import moment from "moment-timezone";
import { logout } from "../../reducers/user/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router";

const routes = require("../../routes.json");

const { Option } = Select;

class RandomizePage extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      date: "",
      studyID: "",
      dose: "",
      consentType: "",
      randomized: false,
      loading: false,
      isEditable: false,
      sites: [],
      formSchemaRandomization: null,
      formSchemaPreRandomization: null,
      preRandomizationData: null,
      consentRecordID: queryParams.get("consentRecordID"),
      siteCode: queryParams.get("siteCode"),
      subjectCode: queryParams.get("subjectCode"),
      participant_id: undefined,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  async componentDidMount() {
    if (
      this.props.prerandomizationConsentStatus &&
      !(this.state.consentRecordID || this.state.siteCode)
    ) {
      this.props.history.push(routes.admin.preconsentRandomization);

      return;
    }

    try {
      const { data } = await getRandomizationSites();
      const [
        formSchemaRandomization,
        formSchemaPreRandomization,
      ] = await Promise.all([
        getCustomFormSchema("randomization"),
        getCustomFormSchema("pre_randomization"),
      ]);

      if (this.state.siteCode && this.state.subjectCode) {
        await this.getRandomizationInitialValues();
      }

      this.setState({
        sites: data.filter((item) => item.site_type === "randomization"),
        formSchemaRandomization: get(formSchemaRandomization, "data"),
        formSchemaPreRandomization: get(formSchemaPreRandomization, "data"),
      });
    } catch (e) {
      console.log(e);
    }
  }

  getRandomizationInitialValues = async () => {
    try {
      const { data } = await postRandomizationInitialValuesRequest({
        'subject_code': this.state.subjectCode,
        'site_code': this.state.siteCode,
      });

      this.setState({
        participant_id: get(data, 'participant_id')
      })
    } catch (e) {
      console.log(e);
    }
  };

  getRandomizationSitesList = async (setFieldsValue, from_site_id) => {
    this.setState({
      errorMessage: null,
      siteListLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getRandomizationSitesRequest(from_site_id);
      this.setState({
        dispensingSites: data.map((site) => ({
          value: get(site, "id"),
          label: get(site, "name"),
          has_own_vials: get(site, "has_own_vials"),
        })),
        siteListLoading: false,
        selectedToSite: null,
      });

      if (data.length === 1 && setFieldsValue) {
        setFieldsValue({ storage_id: get(data, "[0].id") });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        dispensingSites: [],
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }
    this.setState({ siteListLoading: false });
  };

  dataProceed = (values, schema) => {
    const isUpload = Object.keys(schema).some((k) =>
      Object.keys(schema[k].fields).some(
        (o) => schema[k].fields[o].type === "InputUpload"
      )
    );

    let data = {};

    if (isUpload) {
      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (values[key] && values[key].file) {
          formData.append(key, values[key].file);
        } else {
          formData.append(key, values[key]);
        }
      });

      data = formData;
    } else {
      data = { ...values };
    }

    return data;
  };

  handlePreRandomizationSubmit = async (values) => {
    const schema = get(this.state, "formSchemaPreRandomization.schema");
    const data = this.dataProceed(values, schema);

    try {
      await validateCustomForm("pre-randomization", { ...data });

      this.setState({
        preRandomizationData: { ...data },
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }

      throw e;
    }
  };

  handleSubmit = async (values) => {
    const schema = get(this.state, "formSchemaRandomization.schema");
    const isUpload = Object.keys(schema).some((k) =>
      Object.keys(schema[k].fields).some(
        (o) => schema[k].fields[o].type === "InputUpload"
      )
    );

    let data = {};

    if (isUpload) {
      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (values[key] && values[key].file) {
          formData.append(key, values[key].file);
        } else {
          formData.append(key, values[key]);
        }
      });

      data = formData;
    } else {
      data = { ...values };
    }

    data.is_correct = undefined;
    data.is_correct_check = undefined;

    try {
      const { data: resultData } = await postCustomFormRandomization({
        ...data,
        _pre_randomization_data: this.state.preRandomizationData,
        consent_id: this.state.consentRecordID,
        subject_code: this.state.subjectCode,
      });

      this.setState({
        loading: true,
      });

      this.setState({
        date: resultData.randomization_date,
        studyID: resultData.study_id,
        bottle_no: resultData.bottle_no,
        dose: resultData.dose,
        drug_dosage: resultData.drug_dosage,
        treatment_arm_name: resultData.treatment_arm_name,
        new_randomization: get(resultData, "new_randomization"),
        treatment_code: resultData.treatment_code,
        randomized: true,
        loading: false,
      });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }

      throw e;
    }
  };

  handleReset() {
    this.setState({
      date: "",
      studyID: "",
      dose: "",
      randomized: false,
      loading: false,
      isEditable: false,
    });
  }

  onFromChange = (setFieldsValue) => async (value) => {
    const { isDrugManagementActive } = this.props;

    const site = find(this.state.sites, ({ code }) => code === value);
    this.setState({ siteTz: get(site, 'time_zone'), site });
    moment.tz.setDefault(this.props.userTimezone || this.state.siteTz || "UTC");

    if (isDrugManagementActive) {
      if (setFieldsValue) {
        setFieldsValue({ storage_id: null });
      }

      try {
        await this.getRandomizationSitesList(setFieldsValue, value);
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
          return;
        }
        message.error(get(e, "response.data.error", "Error"));
        console.log(e);
      }
    }
  };

  getPostChildren = ({ getFieldDecorator, getFieldValue }) => {
    const { sites } = this.state;
    const { randomizationConfirmStep } = this.props;

    const site = find(sites, ({ code }) => code === getFieldValue("site"));
    const isEditable =
      get(site, "state") === "active" && get(site, "randomization_permitted");

    return randomizationConfirmStep ? (
      <div />
    ) : (
      <Row style={{ width: "100%" }}>
        <Col md={24}>
          <label>
            <b>
              {this.props.i18n.t(
                "NamespaceRandomizeFormSeparate:I verified the randomization above and I confirm that all all the data is correct."
              )}
            </b>
          </label>
          <Form.Item>
            {getFieldDecorator("is_correct", {
              rules: [{ required: true, message: this.props.i18n.t("Required") }],
            })(
              <Select
                disabled={!isEditable}
                style={{ width: "280px", height: "32px" }}
              >
                <Option value="">{this.props.i18n.t("No")}</Option>
                <Option value="yes">{this.props.i18n.t("Yes")}</Option>
              </Select>
            )}
          </Form.Item>
        </Col>
      </Row>
    );
  };

  getPreChildren = ({ getFieldDecorator, getFieldValue, setFieldsValue }) => {
    const { sites, dispensingSites } = this.state;
    const { isDrugManagementActive, randomizationConfirmStep } = this.props;

    if (this.state.siteCode && !getFieldValue("site")) {
      setFieldsValue({ site: this.state.siteCode });

      setTimeout(() => {
        this.onFromChange(setFieldsValue)(this.state.siteCode);
      }, 0);
    }

    const site =
      find(sites, ({ code }) => code === getFieldValue("site")) ||
      this.state.siteCode;

    const storage = find(
      dispensingSites,
      ({ value }) => value === getFieldValue("storage_id")
    );

    const isEditable =
      get(site, "state") === "active" && get(site, "randomization_permitted");

    if (this.state.isEditable !== isEditable) {
      this.setState({ isEditable });
    }

    return (
      <Row style={{ width: "100%" }}>
        {(this.props.randomizationStatusMessage) ? <div>
            <Alert message={<b>{this.props.randomizationStatusMessage}</b>} type="error" />
        </div> : ''}

        {this.state.sites && this.state.sites.length > 0 && (
          <Col md={24}>
            <label>
              <b>{this.props.i18n.t("Site*")}</b>
              <Form.Item>
                {getFieldDecorator("site", {
                  // initialValue: this.state.siteCode || undefined,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t("Please input site id"),
                    },
                  ],
                })(
                  <Select
                    placeholder={this.props.i18n.t("Select site")}
                    onChange={this.onFromChange(setFieldsValue)}
                    disabled={this.state.siteCode}
                  >
                    {sites
                      .sort((a, b) => a.code - b.code)
                      .map(({ code, name }) => (
                        <Select.Option value={code} key={code}>
                          {code} - {name}
                        </Select.Option>
                      ))}
                  </Select>
                )}
              </Form.Item>
            </label>
          </Col>
        )}

        {!this.state.siteListLoading && getFieldValue("site") &&
          (() => {
            if (get(site, "state") !== "active") {
              return (
                <Col md={24}>
                  <Alert
                    type="error"
                    message={this.props.i18n.t(
                      "NamespaceRandomizeFormSeparate:Site is inactive"
                    )}
                  />
                  <br />
                </Col>
              );
            }
          })()}

        {!this.state.siteListLoading && getFieldValue("site") &&
          (() => {
            if (!get(site, "randomization_permitted")) {
              return (
                <Col md={24}>
                  <Alert
                    type="error"
                    message={this.props.i18n.t(
                      "NamespaceRandomizeFormSeparate:Site is not permitted for Randomization."
                    )}
                  />
                  <br />
                </Col>
              );
            }
          })()}

        {isDrugManagementActive && (
          <Col span={24}>
            <label>
              <b>{this.props.i18n.t("Active Fridge*")}</b>
              <Form.Item>
                {getFieldDecorator("storage_id", {
                  rules: [{ required: true, message: this.props.i18n.t("Required") }],
                  initialValue: get(this.props, "drug_location.id", null),
                })(
                  <Select
                    disabled={!isEditable || this.props.siteListLoading}
                    placeholder={this.props.i18n.t("Select")}
                  >
                    {map(dispensingSites, ({ value, label }) => (
                      <Select.Option key={value} value={value}>
                        {label}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </label>
          </Col>
        )}

        {getFieldValue("storage_id") &&
          (() => {
            if (!get(storage, "has_own_vials")) {
              return (
                <Col md={24}>
                  <Alert
                    type="error"
                    message={this.props.i18n.t(
                      "NamespaceRandomizeFormSeparate:Inadequate number of drug packages available in dispensing location. Please request more drugs!"
                    )}
                  />
                  <br />
                </Col>
              );
            }
          })()}

        {!randomizationConfirmStep && (
          <Col md={24}>
            <label>
              <b>{this.props.i18n.t("Password*")}</b>
              <Form.Item>
                {getFieldDecorator("password", {
                  rules: [
                    {
                      required: true,
                    },
                  ],
                })(<Input.Password disabled={!isEditable} />)}
              </Form.Item>
            </label>
          </Col>
        )}
      </Row>
    );
  };

  render() {
    const {
      randomized,
      sites,
      site,
      formSchemaRandomization,
      formSchemaPreRandomization,
      preRandomizationData,
      isEditable,
    } = this.state;

    const { projectConfigurationPreRandomization } = this.props;

    return (
      <div className={classes.wrapper}>
        <Helmet>
          <title>
            {this.props.i18n.t("Trial Management Portal")}:{" "}
            {this.props.i18n.t("Dashboard")}
          </title>
        </Helmet>
        <div className={classes.parentContainer}>
          <div className={classes.content}>
            <h2>{this.props.i18n.t("Start Randomization")}{this.state.subjectCode ? `: ${this.state.subjectCode}` : ""}</h2>
            <div style={{ display: randomized ? "block" : "none" }}>
              <ResultsRandomization
                {...this.state}
                onBackClick={this.handleReset}
              />
            </div>

            <Row>
              <Col md={24} lg={18}>
                {!randomized &&
                  !preRandomizationData &&
                  projectConfigurationPreRandomization && (
                    <div>
                      {formSchemaPreRandomization ? (
                        <FormBuilderCustomView
                          site={site}
                          sites={sites}
                          isEditable
                          schema={formSchemaPreRandomization.schema}
                          name={formSchemaPreRandomization.name}
                          slug="pre_randomization"
                          onSubmit={this.handlePreRandomizationSubmit}
                          saveButton="Next"
                        />
                      ) : (
                        <Icon type="loading" />
                      )}
                    </div>
                  )}
              </Col>
            </Row>

            <Row>
              <Col md={24} lg={18}>
                {!randomized &&
                  (preRandomizationData ||
                    !projectConfigurationPreRandomization) && (
                    <div>
                      {formSchemaRandomization ? (
                        <FormBuilderCustomView
                          site={site}
                          sites={sites}
                          isEditable={isEditable}
                          schema={formSchemaRandomization.schema}
                          name={formSchemaRandomization.name}
                          slug="randomization"
                          postChildren={this.getPostChildren}
                          preChildren={this.getPreChildren}
                          onSubmit={this.handleSubmit}
                          initialValues={{ participant_id: this.state.participant_id }}
                        />
                      ) : (
                        <Icon type="loading" />
                      )}
                    </div>
                  )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  isDrugManagementActive: getDrugManagementStatus(state),
  prerandomizationConsentStatus: getPrerandomizationConsentStatus(state),
  randomizationConfirmStep: getRandomizationConfirmStep(state),
  projectConfigurationPreRandomization: getProjectConfigurationPreRandomization(
    state
  ),
  randomizationStopped: getRandomizationStopped(state),
  randomizationStatusMessage: getRandomizationStatusMessage(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(withNamespaces()(RandomizePage)))
);



// WEBPACK FOOTER //
// ./src/containers/RandomizePage/RandomizePage.js